import styled from 'styled-components';
import { width } from '../../styles/base/variables/layout';

export const GridContainer = styled.div`
  width: calc(100% - ${width.pagePadding * 2}vw);
  max-width: ${width.gridMax}px;
  margin-left: auto;
  margin-right: auto;
`;
